import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';
import {MarketingHeader} from 'shells/typography/marketing-header';

import styles from './header.module.css';

type Props = {
    isGeneric?: string;
    emailAddress?: string;
};

export function Header(props: Props) {
    const emailAddress = props.isGeneric ? '[your recipient’s email address]' : props.emailAddress;

    return (
        <>
            {props.isGeneric && (
                <div className='pad-24'>
                    <div className={styles['preview-top-bar']}>
                        <Body isBold={true} color='dark' size='large'>
                            This is an example unsubscribe page
                        </Body>
                        <Body size='large'>
                            When your recipients click this link at the bottom of your email,
                            they’ll be taken to a page similar to this:
                        </Body>
                    </div>
                </div>
            )}
            <StackLegacy spacing={0}>
                <MarketingHeader>Update my email preferences</MarketingHeader>
                {emailAddress ? (
                    <StackLegacy isHorizontal={true} spacing={4} alignCenter={true}>
                        <Body color='light'>Your email:</Body>
                        <Body isBold={true} color='dark' size='large'>
                            {emailAddress}
                        </Body>
                    </StackLegacy>
                ) : undefined}
            </StackLegacy>
        </>
    );
}
